export default "__VITE_ASSET__c745b58a__"